import React from "react";
import {
  FaPaperPlane,
  FaUserEdit,
  FaEdit,
  FaImage,
  FaCog,
  FaUsers,
  FaUserPlus,
  FaUserMinus,
  FaUserTimes,
  FaExchangeAlt
} from "react-icons/fa";

const notifyColor = "#51a197";

/**
 * Lista de operações com chaves técnicas padronizadas (Internal Technical Names)
 */
const operationList = [
  {
    key: "SendMessageGroup",
    label: "Enviar Mensagem (Broadcast)",
    icon: <FaPaperPlane color={notifyColor} size={28} />,
    type: "circle",
  },
  {
    key: "ChangeGroupName",
    label: "Mudar Nome do Grupo",
    icon: <FaUserEdit color={notifyColor} size={24} />,
    type: "radio",
  },
  {
    key: "ChangeGroupDescription",
    label: "Mudar Descrição",
    icon: <FaEdit color={notifyColor} size={24} />,
    type: "radio",
  },
  {
    key: "ChangeGroupPicture",
    label: "Mudar Imagem",
    icon: <FaImage color={notifyColor} size={24} />,
    type: "radio",
  },
  {
    key: "ChangeGroupSettings",
    label: "Mudar Configuração",
    icon: <FaCog color={notifyColor} size={24} />,
    type: "radio",
  },
  {
    key: "JoinGroup",
    label: "Entrar no Grupo",
    icon: <FaUsers color={notifyColor} size={24} />,
    type: "radio",
  },
  {
    key: "AddAdmin",
    label: "Adicionar Administrador",
    icon: <FaUserPlus color={notifyColor} size={24} />,
    type: "radio",
  },
  {
    key: "RemoveAdmin",
    label: "Remover Administrador",
    icon: <FaUserMinus color={notifyColor} size={24} />,
    type: "radio",
  },
  {
    key: "RemoveParticipant",
    label: "Remover participante",
    icon: <FaUserTimes color={notifyColor} size={24} />,
    type: "radio",
  },
  {
    key: "MoveGroups",
    label: "Mover grupos de campanha",
    icon: <FaExchangeAlt color={notifyColor} size={24} />,
    type: "radio",
  },
];

const Operacoes = ({ selected, setSelected, setEtapaAtual, setOperacaoSelecionada }) => {

  const handleNext = (opKey) => {
    if (setOperacaoSelecionada) {
      setOperacaoSelecionada(opKey);
    }
    setEtapaAtual('campaign');
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
        minHeight: "400px",
        background: "#fff",
        padding: "10px",
        boxSizing: "border-box",
      }}
    >
      <button
        style={{
          marginBottom: "30px",
          background: selected ? notifyColor : "#ccc",
          color: "#fff",
          border: "none",
          borderRadius: "12px",
          padding: "12px 60px",
          fontWeight: "bold",
          fontSize: "16px",
          cursor: selected ? "pointer" : "not-allowed",
          boxShadow: selected ? `0 4px 12px ${notifyColor}44` : "none",
          transition: "all 0.3s ease",
        }}
        onClick={() => {
          if (selected) {
            handleNext(selected);
          }
        }}
        disabled={!selected}
      >
        Próximo
      </button>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
          gap: "20px",
          justifyItems: "center",
          alignItems: "center",
          width: "100%",
          maxWidth: "1100px",
        }}
      >
        {operationList.map((op) => {
          const isSelected = selected === op.key;

          return (
            <div
              key={op.key}
              onClick={() => setSelected(op.key)}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "16px",
                background: isSelected ? "#f0fdf4" : "#f8fafc",
                borderRadius: "16px",
                padding: "18px 24px",
                width: "100%",
                boxSizing: "border-box",
                border: `2px solid ${isSelected ? notifyColor : "#f1f5f9"}`,
                cursor: "pointer",
                transition: "all 0.2s ease",
                boxShadow: isSelected ? "0 4px 6px -1px rgba(0,0,0,0.05)" : "none"
              }}
            >
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  minWidth: "45px",
                }}
              >
                {op.icon}
              </span>
              <span
                style={{
                  flex: 1,
                  fontWeight: "700",
                  color: isSelected ? notifyColor : "#334155",
                  fontSize: "14px",
                }}
              >
                {op.label}
              </span>

              {op.type === "radio" ? (
                <div
                  style={{
                    width: "20px",
                    height: "20px",
                    borderRadius: "50%",
                    border: `2px solid ${isSelected ? notifyColor : "#cbd5e1"}`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "#fff"
                  }}
                >
                  {isSelected && (
                    <div style={{ width: "10px", height: "10px", borderRadius: "50%", background: notifyColor }} />
                  )}
                </div>
              ) : (
                <div
                  style={{
                    background: notifyColor,
                    borderRadius: "50%",
                    width: "30px",
                    height: "30px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setSelected(op.key);
                    handleNext(op.key);
                  }}
                >
                  <FaPaperPlane color="#fff" size={14} />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Operacoes;